import "./TextWithReadMore.scss";
import { Typography } from "@mui/material";
import makeStyles from '@mui/styles/makeStyles';
import { memo, useCallback, useState } from "react";
import BasicButton from "../Components/Buttons/BasicButton";

const useStyles = makeStyles((theme) => ({
    readMoreButton: {
        color: theme.palette.primary.main,
        backgroundColor: 'transparent',
        border: 'none',
        cursor:'pointer', 
        textTransform: "inherit", 
        font: "inherit", 
        letterSpacing: "inherit", 
        lineHeight: "inherit", 
        padding: 0, 
        verticalAlign: "inherit",

        "&:hover": {
            textDecoration: "underline",
            background: "none",
        },
    },
}));

export default memo(function TextWithReadMore ({ text, length = 50, ellipses = " ...", readMore = "show more", readLess = "show less", ...props }) {
	const classes = useStyles();

    const [showLess, setShowLess] = useState(true);    
    
    const handleSetShowClick = useCallback((e) => {
        e.stopPropagation();
        e.nativeEvent.stopImmediatePropagation();

        setShowLess(!showLess);
    }, [setShowLess, showLess]);
    
    if(!text) {
        return <></>
    }
 
    // factor on the added ellipses to see if we should shorten
    const needsToBeShortened = text.length > (length + ellipses.length + readLess.length);

    const displayText = (showLess && needsToBeShortened) ? text.slice(0, length) + ellipses + " " : text + " ";

	return (
        <Typography className="TextWithReadMore" {...props}>
            {displayText}
            {needsToBeShortened && (
                <BasicButton 
                    className={[classes.readMoreButton, "TextWithReadMore-showButton"].join(" ")}
                    onClick={handleSetShowClick}
                    color="primary">
                    { showLess ? readMore : readLess }
                </BasicButton>
            )}
        </Typography>
	);
});